var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import LottieButton from './LottieButton';
import * as React from "react";
import { styled } from "../theme/ThemeHelpers";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    height:25px;\n    padding:0;\n"], ["\n    display: inline-block;\n    height:25px;\n    padding:0;\n"])));
var CheckboxContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    float:left;\n    margin-right:5px;\n    height:25px;\n"], ["\n    float:left;\n    margin-right:5px;\n    height:25px;\n"])));
var LabelContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    line-height:25px;\n"], ["\n    display: inline-block;\n    line-height:25px;\n"])));
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () { var _a; return _this.props.onClick((_a = _this.props.selected) !== null && _a !== void 0 ? _a : false); };
        return _this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, selected = _a.selected;
        return (React.createElement(Container, null,
            React.createElement(CheckboxContainer, null,
                React.createElement(LottieButton, { speed: 4, selected: selected, kind: "fullTransparentButton", onClick: this.onClick, lottie: { url: "./images/lottiIcons/checkbox.json", behaviour: "PlayOnClickToggleDirection", padding: "2px 3px 3px 2px" }, size: "mini" })),
            React.createElement(LabelContainer, null, this.props.label)));
    };
    return Checkbox;
}(React.PureComponent));
export default Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Checkbox.js.map